import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';
import VideoRecorder from '../video-recorder/video-recorder';

// styles , icons and images
import { Container, Col, Card, Row, Modal } from 'react-bootstrap';
import { Button, Typography } from '@material-ui/core';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import dots from '../record/images/more.png';
import './record.style.css';

// this component represents the recorder part of the create and edit visume page

class Record extends Component {
    constructor() {
        super();
        this.state = {
            questions: '',
            progressValue: 0
        }
    }
    progressValue = 0;
    componentWillReceiveProps(props) {
        if (props.data) {
            console.log(props.data)
            // if first question sets by user 
            if (this.state.firstQuestion) {
                let firstQuestion = props.data.questions.filter(question => question.id === this.state.firstQuestion.id);
                if (firstQuestion.length !== 0) {
                    this.setState({ ...this.state, questions: props.data, firstQuestion: firstQuestion[0] , bioFor : props.bioFor });
                }
                else {
                    this.setState({ ...this.state, questions: props.data, firstQuestion: props.data.questions[0] , bioFor : props.bioFor  });
                }
            }
            // if no first question sets before
            else {
                this.setState({ ...this.state, questions: props.data, firstQuestion: props.data.questions[0]  , bioFor : props.bioFor });
            }
        }
    }
    closeAllMenues = () => {
        let menues = document.querySelectorAll('.custom-list');

        menues.forEach(menu => menu.classList.add('d-none'))
    }
    render() {
        const handleClick = (e) => {
            let elem = e.currentTarget;
            if (elem.querySelector('.custom-list')) {
                elem.querySelector('.custom-list').classList.toggle('d-none');
            }
        }
        if (!this.state.questions || !this.state.firstQuestion) {
            return (
                <div><h5 className="text-dark">Loading....</h5></div>
            )
        }
        else {
            let firstQuestion = this.state.firstQuestion;
            const handleClose = () => this.setState({ ...this.state, show: false });
            return (
                <div className="record">
                    <Container fluid className="m-0 p-0">
                        <Row className="m-0">
                            <Col xs={12} className="pr-2 pl-2 pt-1 pb-3">
                                <div>
                                    <div className="title captialize">
                                        <h4>{firstQuestion.title}</h4>
                                    </div>
                                    <VideoRecorder data={firstQuestion} />
                                </div>
                            </Col>
                            {this.state.questions.questions.map(question => 
                                {
                                    if (question.video) {
                                        return(
                                            <Col key={question.id} data-id={question.id} className="p-2 card-question" sm={3} xs={6}>
                                                <Card className="border-0" key={question.id}>
                                                    <button className="record-card bg-transparent border-0 p-0 p-relative"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.setState({ ...this.state, firstQuestion: question })
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                        }} >
                                                        <div className="overlay rounded"></div>
                                                        <Card.Img src={question.video.frame.url} style={{ maxHeight: '5.8rem' }} alt="video poster" className="rounded" width="100%" />

                                                    </button>
                                                    <div className="success " data-uploaded={question.id}>
                                                        <CheckCircleIcon style={{ fontSize: "21px", color: "#E85A19" }} />
                                                    </div>
                                                    <Row className="m-0 pt-2 pb-2">
                                                        <Col xs={10} className="text-left p-0">{question.title}</Col>
                                                        <Col xs={2} className="text-right p-0">
                                                            <button
                                                                className="bg-transparent border-0 pt-1 pb-1 p-0"
                                                                onClick={handleClick}>
                                                                <img src={dots} alt="dots" />
                                                                <ul className="shadow custom-list custom-position d-none" style={{ top: "1.5rem", left: "unset", right: "0" }}>
                                                                    <li className="list-style-none text-center">
                                                                        <button
                                                                            className="bg-transparent border-0  pr-2 pl-2"
                                                                            type="button"
                                                                            onClick={e => {
                                                                                this.setState({ ...this.state, firstQuestion: question, show: true })
                                                                            }}
                                                                        >View</button>
                                                                    </li>
                                                                    <li className="list-style-none text-center">
                                                                        <button
                                                                            className="bg-transparent border-0  pr-2 pl-2"
                                                                            type="button"
                                                                            onClick={() => {
                                                                                this.setState({ ...this.state, firstQuestion: question });
                                                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                            }}
                                                                        >Record</button>
                                                                    </li>
                                                                    <li className="list-style-none text-center delete-option p-0">
                                                                        <button
                                                                            className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3"
                                                                            type="button"
                                                                            onClick={e => {
                                                                                let id = question.id;
                                                                                this.props.delete_question({
                                                                                    variables: {
                                                                                        "question_id": id
                                                                                    }
                                                                                }).then((res) => {
                                                                                    if (res.data.questionDelete.Status.code === 200) {
                                                                                        if (this.state.questions.questions.length < 1) {
                                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                            let list = document.getElementById("left-tabs-example");
                                                                                            let nav_items = list.querySelectorAll(".nav-item a");
                                                                                            nav_items[1].click();

                                                                                            nav_items[2].setAttribute("aria-disabled", "true")
                                                                                            nav_items[2].classList.add("disabled")
                                                                                            nav_items[3].setAttribute("aria-disabled", "true")
                                                                                            nav_items[3].classList.add("disabled")
                                                                                        }
                                                                                    }
                                                                                }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                                            }}
                                                                        >Delete</button>
                                                                    </li>
                                                                </ul>
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )
                                    }
                                    else{
                                        return(
                                            <Col key={question.id} data-id={question.id} className="p-2 card-question" sm={3} xs={6}>
                                                <Card className="border-0" key={question.id}>
                                                    <button
                                                        className="record-card bg-transparent border-0 pr-0 pl-0"
                                                        onClick={() => {
                                                            this.setState({ ...this.state, firstQuestion: question });
                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                        }}                                                   >
                                                        <div className="bg-grey w-100 p-4 text-center rounded">
                                                            <CropOriginalIcon className="text-grey" style={{ fontSize: "45px" }} />
                                                        </div>
                                                    </button>
                                                    <div className="success d-none" data-uploaded={question.id}>
                                                        <CheckCircleIcon style={{ fontSize: "21px", color: "#E85A19" }} />
                                                    </div>
                                                    <Row className="m-0 pt-2 pb-2">
                                                        <Col xs={10} className="text-left p-0">{question.title}</Col>
                                                        <Col xs={2} className="text-right p-0">
                                                            <button
                                                                className="bg-transparent border-0 pt-1 pb-1 p-0"
                                                                onClick={handleClick}>
                                                                <img src={dots} alt="dots" />
                                                                <ul className="shadow custom-list custom-position d-none" style={{ top: "1.5rem", left: "unset", right: "0" }}>
                                                                    <li className="list-style-none text-center">
                                                                        <button
                                                                            className="bg-transparent border-0  pr-2 pl-2"
                                                                            type="button"
                                                                            onClick={() => {
                                                                                this.setState({ ...this.state, firstQuestion: question });
                                                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                            }}
                                                                        >Record</button>
                                                                    </li>
                                                                    <li className="list-style-none text-center delete-option p-0">
                                                                        <button
                                                                            className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3"
                                                                            type="button"
                                                                            onClick={e => {
                                                                                let id = question.id;
                                                                                this.props.delete_question({
                                                                                    variables: {
                                                                                        "question_id": id
                                                                                    }
                                                                                }).then((res) => {
                                                                                    if (res.data.questionDelete.Status.code === 200) {
                                                                                        if (this.state.questions.questions.length < 1) {
                                                                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                            let list = document.getElementById("left-tabs-example");
                                                                                            let nav_items = list.querySelectorAll(".nav-item a");
                                                                                            nav_items[1].click();

                                                                                            nav_items[2].setAttribute("aria-disabled", "true")
                                                                                            nav_items[2].classList.add("disabled")
                                                                                            nav_items[3].setAttribute("aria-disabled", "true")
                                                                                            nav_items[3].classList.add("disabled")
                                                                                        }
                                                                                    }
                                                                                }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                                                                            }}
                                                                        >Delete</button>
                                                                    </li>
                                                                </ul>
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )
                                    }
                                }
                            )}
                            {/* modal for showing video */}
                            <Modal
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter pr-0"
                                centered
                                className="row m-0 modal-video"
                                show={this.state.show}
                                onHide={handleClose}>
                                <Col xs={12} className="p-0">
                                    <Modal.Body className="p-0 bg-white rounded border-b-0">
                                        <Col xs={12} className="text-left  bold  captialize">
                                            <h6 className='mb-0 pt-3 pb-3'>{this.state.firstQuestion.title}</h6>
                                        </Col>
                                        <Col xs={12} className="p-0 bg-black rounded">
                                            <video controls autoPlay title={this.state.firstQuestion.title} src={(this.state.firstQuestion.video) ? this.state.firstQuestion.video.url : ''} className='iframe-sm ' width="100%" style={{ maxHeight: '33rem' }}></video>
                                        </Col>
                                    </Modal.Body>
                                </Col>
                            </Modal>
                            <Col xs={12} className="p-2 pb-1">
                                <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                            </Col>
                        </Row>
                    </Container>
                    <div className="w-100">
                        <Col xs="6" className="d-inline-block p-2  pt-4 text-left">
                            <Button 
                                type="button"
                                size="large"
                                onClick={() => {
                                    let list = document.getElementById("left-tabs-example");
                                    let nav_items = list.querySelectorAll(".nav-item a");
                                    this.closeAllMenues()
                                    if(this.state.bioFor === 'applyJob'){
                                        nav_items[0].click();
                                    }
                                    else{
                                        nav_items[1].click();
                                    }
                                }}
                                className="btn-white-outline pr-5 pl-5 record-back-btn"
                                variant="contained"
                            >Back</Button>
                        </Col>
                        <Col xs="6" className="d-inline-block p-2 pt-4 text-right">
                            <Button
                                size="large"
                                className="btn-orange-gradiant pr-5 pl-5 record-next-btn"
                                variant="contained"
                                type="submit"
                                onClick={() => {
                                    // check if all questions have videos 
                                    this.closeAllMenues()
                                    let flag = [];
                                    this.state.questions.questions.map(question => {
                                        if (!question.video) {
                                            flag.push(0);
                                        }
                                        else {
                                            flag.push(1);
                                        }
                                    })
                                    if (flag.includes(0)) {
                                        this.setState({ ...this.state, errorMessage: 'You must record a video for each question.' })
                                        return false;
                                    }
                                    else {
                                        //go to next form  and make it not dissappled !
                                        this.setState({ ...this.state, errorMessage: '' })
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                        let list = document.getElementById("left-tabs-example");
                                        let nav_items = list.querySelectorAll(".nav-item a");
                                        console.log(nav_items)
                                        if (nav_items) {
                                            if (nav_items[3]) {
                                                nav_items[3].click();
                                            } else {
                                                nav_items[2].click();
                                            }
                                        }
                                        return true;
                                    }
                                }}
                            >Next</Button>
                        </Col>
                    </div>
                </div>
            );
        }
    }
}

const GET_QUESTIONS = gql`
query($id : Int !){
    bioYours(id: $id){
        id
        title
        brif
        is_Draft
        created_at
        updated_at
        questions
        { id    
          title
          maximum_time
          video{
            id
            url
            frame{
              url
            }
          }
        }
    }
  }
`
const DELETE_QUESTION = gql`
mutation($question_id :  Int ! ){
    questionDelete(Inputs:{
      id: $question_id
    }){
      Status{
        code
      }
    }
  }
  
`

export default compose(
    graphql(GET_QUESTIONS, {
        name: "questions"
    }),
    graphql(DELETE_QUESTION, {
        name: "delete_question"
    })
)(withRouter(Record));
